module.exports = __webpack_public_path__ + "static/media/leana-baechtold-leana-natura.f9ab0d35.jpg";